import {
	GET_CHART_COUNTER,
	GET_CHART_COUNTER_SUCCESS,
	GET_CHART_COUNTER_FAILURE,
	SET_CHART_COUNTER,
} from './types';

export const defaultState = {
	data: { feed: 0, favorites: 0, snapshots: 0 },
	isLoading: false,
	isLoaded: false,
	error: null,
};

export type IChartCounterState = typeof defaultState;

export const chartCounter = (
	state = defaultState,
	action: any
): IChartCounterState => {
	const { payload, type } = action;
	switch (type) {
		case GET_CHART_COUNTER:
			return {
				...state,
				isLoading: true,
				error: null,
			};
		case GET_CHART_COUNTER_SUCCESS:
			return {
				...state,
				data: payload,
				isLoading: false,
				isLoaded: true,
				error: null,
			};
		case GET_CHART_COUNTER_FAILURE:
			return {
				...state,
				isLoading: false,
				isLoaded: true,
				error: payload,
			};
		case SET_CHART_COUNTER:
			const res = Object.entries(payload)[0];
			const type = res[0] as keyof typeof defaultState.data;
			const count = res[1] as number;
			return {
				...state,
				data: { ...state.data, [type]: count + state.data[type] },
			};

		default:
			return state;
	}
};
